$(function () {

    if ($('.filter-trigger').length > 0) {
        $('.filter-trigger').on('click', function (e) {
            e.preventDefault();
            var $this = $(this)
            $this.toggleClass('chevron_close chevron_open')
            var $list = $this.next()
            $list.slideToggle()
            var $message = $('#filter-message');
            $message.fadeToggle(300, 'swing');
        })

        $('input.form-check-input').change(function () {
            if ($('input.form-check-input').is(':checked')) {
                $('#filter-message').html('filter(s) selected. this may limit results')
            } else {
                $('#filter-message').html(' ');
            }
        })
    }

    //get user location

    var $locationButton = $('#form_location_button');
    if ($locationButton.length) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition, showError, {timeout: 10000, maximumAge: 0} );
        } else {
            console.log("Geolocation is not supported by this browser.");
            $('#form_location_button').addClass('disabled').html('<span class="locationarrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><path d="M443.683 4.529L27.818 196.418C-18.702 217.889-3.39 288 47.933 288H224v175.993c0 51.727 70.161 66.526 91.582 20.115L507.38 68.225c18.905-40.961-23.752-82.133-63.697-63.696z"/></svg></span>Location not supported');
        }
        $locationButton.on('click', function (e) {
            e.preventDefault();
            if (($('#form_location [name="origin"]').val() === '') || $locationButton.hasClass('disabled') ) {
                console.log('Accessing location information');
                return
            }  else {
                $('#form_location').submit();
            }
        })
    }

    function showPosition(position) {
        var localCoord = position.coords.latitude + "," + position.coords.longitude;
        $('#form_location [name="origin"]').val(localCoord);
        $('#form_location_button').removeClass('disabled').html('<span class="locationarrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><path d="M443.683 4.529L27.818 196.418C-18.702 217.889-3.39 288 47.933 288H224v175.993c0 51.727 70.161 66.526 91.582 20.115L507.38 68.225c18.905-40.961-23.752-82.133-63.697-63.696z"/></svg></span>Find my nearest office');
    }

    function showError(error) {
        switch (error.code) {
            case error.PERMISSION_DENIED:
                $('#form_location_button').addClass('disabled').html('<span class="locationarrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><path d="M443.683 4.529L27.818 196.418C-18.702 217.889-3.39 288 47.933 288H224v175.993c0 51.727 70.161 66.526 91.582 20.115L507.38 68.225c18.905-40.961-23.752-82.133-63.697-63.696z"/></svg></span>Blocked by user');
                break;
            case error.POSITION_UNAVAILABLE:
                $('#form_location_button').addClass('disabled').html('<span class="locationarrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><path d="M443.683 4.529L27.818 196.418C-18.702 217.889-3.39 288 47.933 288H224v175.993c0 51.727 70.161 66.526 91.582 20.115L507.38 68.225c18.905-40.961-23.752-82.133-63.697-63.696z"/></svg></span>Location unavailable');
                break;
            case error.TIMEOUT:
                $('#form_location_button').addClass('disabled').html('<span class="locationarrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><path d="M443.683 4.529L27.818 196.418C-18.702 217.889-3.39 288 47.933 288H224v175.993c0 51.727 70.161 66.526 91.582 20.115L507.38 68.225c18.905-40.961-23.752-82.133-63.697-63.696z"/></svg></span>Location Timed out');
                break;
            case error.UNKNOWN_ERROR:
                $('#form_location_button').addClass('disabled').html('<span class="locationarrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><path d="M443.683 4.529L27.818 196.418C-18.702 217.889-3.39 288 47.933 288H224v175.993c0 51.727 70.161 66.526 91.582 20.115L507.38 68.225c18.905-40.961-23.752-82.133-63.697-63.696z"/></svg></span>Unknown error');
                break;
        }
    }


    //get coordinates of city

    var $dropdownForm = $('#form_dropdown_select');
    if ($dropdownForm.length) {
        $dropdownForm.on('change', function (e) {
            e.preventDefault();
            var selection = this.value;
            if (selection === 'null') {
                return
            }
            // getLatLng(selection);
            $('#form_dropdown [name="query"]').val(selection);
            $('#form_dropdown').submit();
        });
    }



    function getLatLng(city) {
        var address = city;
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            'address': address
        }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                console.log(results[0])
                var Lat = results[0].geometry.location.lat();
                var Lng = results[0].geometry.location.lng();
                var one = results[0].geometry.bounds.getNorthEast().lat();
                var two = results[0].geometry.bounds.getNorthEast().lng();
                var three = results[0].geometry.bounds.getSouthWest().lat();
                var four = results[0].geometry.bounds.getSouthWest().lng();
                var returnValue = Lat + ',' + Lng;
                var radius = getDistanceFromLatLonInKm(one,two,three,four);
            } else {
                var returnValue = "57.1425543,-2.1122146";
                var radius = "1000"
            }
            if (returnValue) {
                $('#form_dropdown [name="origin"]').val(returnValue);
                $('#form_dropdown [name="maxdist"]').val(radius);
                $('#form_dropdown').submit();
            }
        });
    }


    //get size of country

    function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2-lat1);  // deg2rad below
        var dLon = deg2rad(lon2-lon1);
        var a =
            Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon/2) * Math.sin(dLon/2)
        ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        var d = R * c; // Distance in km

        d = d / 2;
        return d;
    }

    function deg2rad(deg) {
        return deg * (Math.PI/180)
    }
});